import type { Build, Project, Revision, RevisionLicense, Task } from '../model-typings';

export const COUNT_DEFAULT = 50;
export const COUNT_MAX = 100;
export const COUNT_MIN = 25;
export const PAGE_DEFAULT = 1;
export const PAGE_MAX = Infinity;
export const PAGE_MIN = 1;

export enum Status {
  InProgress = 'analyzing', // In progress build
  Analyzed = 'analyzed', // Steady state
  Failed = 'failed', // Error
  Unknown = 'unknown', // Unresolved or unsupported
}

export const allStatuses: Readonly<Status[]> =
  Object.freeze([Status.Analyzed, Status.Failed, Status.InProgress, Status.Unknown]);

export type BuildWithTask = Build & {
  task?: Task;
};

export type RevisionWithAssociations = Revision & {
  project?: Project;
  licenses?: RevisionLicense[];
  builds?: Build[];
};

export type ProjectDependencyScope = {
  scope: 'project',
  revision: string,
};

export type ReleaseGroupDependencyScope = {
  scope: 'releaseGroup',
  projectGroupId: number,
  projectGroupReleaseId: number,
};

export type GlobalDependencyScope = {
  scope: 'global';
  organizationId: number;
}

export type DependencyScope = ProjectDependencyScope | ReleaseGroupDependencyScope | GlobalDependencyScope;

/**
 * This matches the grouped license shape returned by DepsV1 and is needed for our issue scanners
 * @example
 * {
 *   licenseId: 'MIT',
 *   ignored: false,
 *   licenseGroupId: 1,
 *   group: {
 *     signature: 'MIT OR ISC',
 *     isDeclared: true,
 *     ignored: false,
 *   }
 * }
 */
export type GroupedLicense = {
  licenseId: string;
  ignored: boolean;
  licenseGroupId: number;
  group: { isDeclared: boolean; ignored: boolean; signature: string };
};
